import { all } from "axios";
import { Button } from "components/Button/Button";
import { Input, Select, TextArea } from "components/Form";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useLayoutEffect, useState } from "react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import {
  addItemSalesCustomer,
  getProductDropdownList,
} from "services/itemsellsmanagement";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "components/Button/IconButton";
// import {
//   addProduct,
//   getCategoryDropdownList,
// } from "services/inventorymanagement";
import qrcode from "assets/images/qrcode.png";

export default function AddCustomer() {
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});
  const [errorFieldArray, setErrorFieldArray] = useState([]);
  const [allProduct, setAllProduct] = useState([]);
  const [allProductPrice, setAllProductPrice] = useState([]);

  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  const [itemsList, setItemList] = useState([]);

  // ****************************** Fetch All Categories *****************************************
  const fetchAllCategories = async () => {
    showLoader();
    try {
      const res = await getProductDropdownList();
      hideLoader();
      if (res.code === 200) {
        setAllProduct(
          res.data.product.map(({ productId, productName, productPrice }) => {
            return { label: productName, value: productId };
          }) || []
        );
        setAllProductPrice(
          res.data.product.map(({ productPrice }) => {
            return productPrice;
          }) || []
        );
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useLayoutEffect(() => {
    fetchAllCategories();
    if (itemsList.length == 0) {
      setItemList((prevItems) => [
        ...prevItems,
        { itemQuantity: 0, itemPrice: 0.0 },
      ]);
      setErrorFieldArray((prevItems) => [...prevItems, {}]);
    }
    // fetchAllRoles();
  }, []);

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!data.customerName) {
      errorField["customerName"] = "Please Enter Customer Name";
      formIsValid = false;
    }
    if (!data.customerMobile) {
      errorField["customerMobile"] = "Please Enter Customer Mobile";
      formIsValid = false;
    }else if (data.customerMobile.length !== 10) {
      errorField["mobiles"] = "Mobile number must be 10 digits";
      formIsValid = false;
    }
    if (!data.paymentMode) {
      errorField["paymentMode"] = "Please Enter Payment Mode";
      formIsValid = false;
    }
    itemsList.map((data, i) => {
      if (!data.item) {
        errorFieldArray[i].item = `Please Enter Item ${i + 1}`;
        formIsValid = false;
      }
      if (!data.itemQuantity) {
        errorFieldArray[i].itemQuantity = `Please Enter Item ${i + 1} Quantity`;
        formIsValid = false;
      }
      // if (!data.itemPrice) {
      //   errorFieldArray[i].itemPrice = `Please Enter Item ${i + 1} Price`;
      //   formIsValid = false;
      // }
    });

    setErrorField(errorField);
    return formIsValid;
  };
  //*********************Submit Product Handler********************************** *//
  const submitProduct = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        console.log(itemsList);
        let tempArr =
          itemsList.map(({ item, itemQuantity, productPrice }) => {
            return { id: item, quantity: itemQuantity };
          }) || [];
        const res = await addItemSalesCustomer({
          customerName: data.customerName,
          customerMobile: data.customerMobile,
          totalQuantity: data.totalQuantity,
          totalAmount: data.totalAmount,
          item: tempArr,
          paymentMode: data.paymentMode,
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  //   ************************************* Handle Add Item *************************************
  const handleAddItem = () => {
    setItemList((prevItems) => [
      ...prevItems,
      { itemQuantity: 0, itemPrice: 0 },
    ]);
    setErrorFieldArray((prevItems) => [...prevItems, {}]);
  };
  //   ************************************* Handle Remove Item *************************************
  const handleRemoveItem = (itemToRemove) => {
    // Filter out the item to remove
    setItemList((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    setErrorFieldArray((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
  };

  //   ************************************* handleChange ********************************************
  const checkDropDownValue = (value) => {
    let flag = true;
    if (itemsList.length > 1) {
      itemsList.map(({ item }) => {
        console.log(value, item);
        if (item == value) {
          flag = false;
        }
      });
    }
    return flag;
  };

  const handleChange = (i, e) => {
    const { name, value } = e.target;
    // console.log(checkDropDownValue())
    const updatedItemsList = [...itemsList];
    if (checkDropDownValue(value)) {
      updatedItemsList[i] = { ...updatedItemsList[i], [name]: value };
      if (name == "item") {
        allProduct.map((data, j) => {
          if (data.value == updatedItemsList[i].item) {
            updatedItemsList[i] = {
              ...updatedItemsList[i],
              itemPrice2: allProductPrice[j],
            };
            updatedItemsList[i] = {
              ...updatedItemsList[i],
              itemPrice: "0.00",
            };
          }
        });
      }
      setItemList(updatedItemsList);
    } else {
      updatedItemsList[i] = { ...updatedItemsList[i], [name]: "" };
      setItemList(updatedItemsList);
      errorFieldArray[i].item = "Please select another item";
      toast.error("Item is already selected");
      toast.error("Please select another item");
    }
  };
  //   ******************************************* Set Total Amount And Quantity **********************************************
  useEffect(() => {
    const add = () => {
      let totalQuantity = 0;
      let totalAmount = 0;

      // Calculate totalQuantity and totalAmount using reduce
      itemsList.forEach((item) => {
        totalQuantity += Number(item.itemQuantity || 0); // Default to 0 if not set
        totalAmount += Number(item.itemPrice || 0); // Default to 0 if not set
      });

      // Set the state with calculated values
      setData({
        ...data,
        totalQuantity: totalQuantity,
        totalAmount: totalAmount,
      });
    };

    add();
  }, [itemsList]);

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap"></div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                Add Customer
              </h4>
            </div>
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitProduct}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="customerName"
                                value={data.customerName}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value,
                                  });
                                }}
                                placeholder="Enter Customer Name"
                                className={`form-control `}
                                maxLength={50}
                                label="Customer Name"
                                error={errorField.customerName}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="customerMobile"
                                value={data.customerMobile}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="Enter Customer Mobile"
                                className={`form-control `}
                                maxLength={10}
                                label="Customer Mobile"
                                error={errorField.customerMobile}
                                required
                              />
                              {errorField.mobiles && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {errorField.mobiles}
                                </span>
                              )}
                            </div>
                            {itemsList.length >= 0 &&
                              itemsList.map((data, i) => (
                                <>
                                  <div className="col-sm-4  col-form-label">
                                    <Select
                                      name={`item`}
                                      placeholder={`Select Item ${i + 1}`}
                                      //   onChange={(e) => {
                                      //     const { name, value } = e.target;
                                      //     setData({ ...data, [name]: value });
                                      //   }}
                                      onChange={(e) => handleChange(i, e)}
                                      //   value={data.item[i]}
                                      value={data.item}
                                      className={`form-control `}
                                      label={`Item ${i + 1}`}
                                      error={errorFieldArray[i].item}
                                      required
                                    >
                                      <option value="">
                                        Select Item {i + 1}
                                      </option>
                                      {allProduct &&
                                        allProduct.map(({ label, value }) => (
                                          <option value={value} key={value}>
                                            {label}
                                          </option>
                                        ))}{" "}
                                    </Select>
                                  </div>
                                  <div
                                    className={
                                      itemsList.length > 1
                                        ? "col-sm-3 col-form-label"
                                        : "col-sm-4 col-form-label"
                                    }
                                  >
                                    <Input
                                      type="text"
                                      name={`itemQuantity`}
                                      value={data.itemQuantity}
                                      //   onChange={(e) => {
                                      //     const { value, name } = e.target;
                                      //     setData({
                                      //       ...data,
                                      //       [name]: value.replace(/\D/g, ""),
                                      //     });
                                      //   }}
                                      onChange={(e) => {
                                        const { name, value } = e.target;
                                        const updatedItemsList = [...itemsList];
                                        updatedItemsList[i] = {
                                          ...updatedItemsList[i],
                                          [name]: value.replace(/\D/g, ""),
                                        };
                                        updatedItemsList[i] = {
                                          ...updatedItemsList[i],
                                          itemPrice:
                                            value *
                                              updatedItemsList[i].itemPrice2 ||
                                            "0.00",
                                        };
                                        setItemList(updatedItemsList);
                                      }}
                                      placeholder={`Enter Item ${i + 1} Quantity`}
                                      className={`form-control `}
                                      maxLength={10}
                                      label={`Item ${i + 1} Quantity`}
                                      error={errorFieldArray[i].itemQuantity}
                                      required
                                    />
                                  </div>
                                  <div
                                    className={
                                      itemsList.length > 1
                                        ? "col-sm-3 col-form-label"
                                        : "col-sm-4 col-form-label"
                                    }
                                  >
                                    <label className="my-1">{`Item ${i + 1} Price`}</label>
                                    <input
                                      disabled
                                      readOnly
                                      type="text"
                                      name={`itemPrice`}
                                      value={itemsList[i].itemPrice}
                                      //   onChange={(e) => {
                                      //     const { value, name } = e.target;
                                      //     setData({
                                      //       ...data,
                                      //       [name]: value.replace(/\D/g, ""),
                                      //     });
                                      //   }}
                                      onChange={(e) => {
                                        const { name, value } = e.target;
                                        const updatedItemsList = [...itemsList];
                                        updatedItemsList[i] = {
                                          ...updatedItemsList[i],
                                          [name]: value.replace(/\D/g, ""),
                                        };
                                        setItemList(updatedItemsList);
                                      }}
                                      placeholder={`Enter Item ${i + 1} Price`}
                                      className={`form-control `}
                                      maxLength={10}
                                      label={`Item ${i + 1} Price`}
                                      error={errorFieldArray[i].itemPrice}
                                      required
                                    />
                                  </div>
                                  {itemsList.length > 1 && (
                                    <div
                                      className={
                                        itemsList.length > 1
                                          ? "col-sm-2 col-form-label"
                                          : "col-sm-0 col-form-label"
                                      }
                                    >
                                      <IconButton
                                        onClick={() => handleRemoveItem(data)}
                                        // {...submitButtonElement}
                                        style={{
                                          marginRight: "5px",
                                          marginTop: "33px",
                                        }}
                                      >
                                        <DeleteIcon sx={{ color: "#f00" }} />
                                      </IconButton>
                                    </div>
                                  )}
                                </>
                              ))}

                            {itemsList.length < allProduct.length && (
                              <div className="col-sm-12  col-form-label">
                                <Button
                                  onClick={handleAddItem}
                                  // {...submitButtonElement}
                                  style={{ marginRight: "5px" }}
                                >
                                  Add Item
                                </Button>
                              </div>
                            )}
                            <div className="col-sm-6  col-form-label">
                              <label className="my-1">{"Total Quantity"}</label>
                              <input
                                readOnly
                                disabled
                                type="text"
                                name="totalQuantity"
                                value={data.totalQuantity}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="Enter Total Quantity"
                                className={`form-control `}
                                maxLength={10}
                                label="Total Amount"
                                error={errorField.totalQuantity}
                                required
                              />
                            </div>
                            <div className="col-sm-6  col-form-label">
                              <label className="my-1">{"Total Amount"}</label>
                              <input
                                readOnly
                                disabled
                                type="text"
                                name="totalAmount"
                                value={data.totalAmount}
                                onChange={(e) => {
                                  const { value, name } = e.target;
                                  setData({
                                    ...data,
                                    [name]: value.replace(/\D/g, ""),
                                  });
                                }}
                                placeholder="Enter Total Amount"
                                className={`form-control `}
                                maxLength={20}
                                label="Total Amount"
                                // error={errorField.totalAmount}
                                // required
                              />
                            </div>
                            <div className="col-sm-6  col-form-label">
                              <Select
                                name={`paymentMode`}
                                placeholder={`Select Payment Mode`}
                                //   onChange={(e) => {
                                //     const { name, value } = e.target;
                                //     setData({ ...data, [name]: value });
                                //   }}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setData({ ...data, [name]: value });
                                }}
                                //   value={data.item[i]}
                                value={data.paymentMode}
                                className={`form-control `}
                                label={`Payment Mode`}
                                error={errorField.paymentMode}
                                required
                              >
                                <option value="">Select Payment Mode</option>
                                {["Offline", "QR Code"].map((data) => {
                                  return (
                                    <option value={data} key={data}>
                                      {data}
                                    </option>
                                  );
                                })}
                              </Select>
                            </div>
                            {data.paymentMode == "QR Code" && (
                              <div className="col-md-6 text-center mt-3">
                                <img
                                  src={qrcode}
                                  alt="QR Code"
                                  style={{ width: "200px", height: "200px" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <Button
                      to={-1}
                      // {...submitButtonElement}
                      style={{ marginRight: "5px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      // {...submitButtonElement}
                    >
                      {/* Add Customer */}
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
